<template>
    <div class="container">
        <div>
            <div class="row page-content">
                <div class="col-12">
                    <h1 class="page-heading text-dark">
                        <img src="/assets/dipocaco/pocas/search.png" alt="search-poca" class="page-poca">
                        {{ $t('search.title') }}
                    </h1>
                </div>

                <div class="col-12">
                    <input type="search" id="search-field" class="form-control w-80" v-model="searchQuery" :placeholder="$t('search.placeholder')">

                    <div class="mt-1 form-group form-check form-switch">
                        <input type="checkbox" class="form-check-input" v-model="highlightOwned" id="highlightOwned">
                        <label class="form-check-label" for="highlightOwned">{{ $t('search.highlightOwned') }}</label>
                    </div>
                </div>

                <div v-if="searchResults.length > 0" class="col-12 p-0" id="card-collection" style="display: flex; flex-direction: column-reverse;">
                    <div class="row p-0">
                        <div class="col-12">
                            {{ $t('search.found', {results: resultsCount}) }} {{ resultsCount > 300 ? $t('search.cutResults') : ''}}
                        </div>
                        <div v-for="card in searchResults"
                             :class="'col-xxl-1 col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4 text-center collection-card '+(highlightOwned && !collectedIds.includes(card.id) ? 'card-not-in-collection' : '')">
                            <a href="javascript:" class="text-left mb-2" v-on:click="cardClick(card)">
                                <img :src="getSmallCardImageUrl(card)" style="width: auto; max-width: 100%;" class="card-thumbnail">
                            </a>
                        </div>
                    </div>
                </div>
                <loading-spinner v-if="!loadingDone"/>
                <div v-if="errorMessage" class="col-12">
                    <div class="alert alert-info">
                        {{ errorMessage }}
                    </div>
                </div>
                <div v-if="loadingDone && searchQuery.length >= 3 && searchResults.length === 0" class="col-12 text-center">
                    <img src="/assets/dipocaco/pocas/error.png" alt="" class="not-found-poca">
                </div>
            </div>
        </div>

        <card-detail-view-canvas :card="activeCard" :gallery="true"/>
    </div>
</template>


<script>
import axios from "axios";
import CardDetailViewCanvas from "../parts/CardDetailViewCanvas.vue";
import CardService from "../../CardService.js";
import LoadingSpinner from "../parts/LoadingSpinner.vue";

export default {
    name: "CardSearch",
    components: {LoadingSpinner, CardDetailViewCanvas},
    data() {
        return {
            loadingDone: true,
            searchQuery: '',
            activeCard: null,
            searchResults: [],
            errorMessage: '',
            noResultsFound: false,
            highlightOwned: true,
            collectedIds: [],
            resultsCount: 0
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.loadCollectedIds();

        if (this.$route.params.searchQuery) {
            this.searchQuery = this.$route.params.searchQuery;
            this.fetchSearchResults();
        }
    },
    watch: {
        searchQuery(val) {
            if (val.trim().length > 2) {
                this.errorMessage = '';
                document.getElementById('search-field').classList.remove('is-invalid');
                this.fetchSearchResults();
            } else {
                this.searchResults = [];
                document.getElementById('search-field').classList.add('is-invalid');
                this.errorMessage = this.$i18n.t('search.minLength');
            }
        }
    },
    methods: {
        fetchSearchResults() {
            this.loadingDone = false;
            this.noResultsFound = false;

            axios.get('/api/cards/search?q=' + this.searchQuery).then(response => {
                if (response.data.results.length > 0) {
                    console.log(response.data)
                    this.searchResults = response.data.results;
                    this.resultsCount = response.data.countAll;
                    this.activeCard = this.searchResults[0];
                } else {
                    this.searchResults = [];
                    this.errorMessage = this.$i18n.t('search.noResults');
                    this.noResultsFound = true;
                }

                this.loadingDone = true;
            })
        },
        cardClick(card) {
            this.activeCard = card;
            this.$forceUpdate();
            $("#card-detail-view-canvas").offcanvas('toggle');
        },
        getSmallCardImageUrl(card) {
            return CardService.getSmallCardImageUrl(card);
        },
        loadCollectedIds() {
            axios.get('/api/user/collected-ids').then(response => {
                this.collectedIds = Object.values(response.data);
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.page-heading {
    background-image: url("/assets/dipocaco/pocas/search-poca.jpg");
    background-position: center 45%;
}

img {
    border-radius: 5px;
}

.row div {
    border: none;
    margin-bottom: 1em;
}

a {
    text-decoration: none;
}

.form-control {
    max-width: 100%;
}

.collection-card {
    margin-bottom: 1em !important;
}

.card-not-in-collection {
    filter: grayscale(100%);
}

.card-markers {
    font-size: 1.5em;
    font-weight: bold;
    margin-top: -1em;
    display: flex;
    position: absolute;
}

.set-logo {
    max-height: 4em;
    max-width: 100%;
}

.set-icon {
    max-height: 1.8em;
}

.list-group-item {
    vertical-align: middle;
    height: 5em;
}

.series-name-heading {
    margin-bottom: 1em;
}

.set-display-logo {
    max-height: 6em;
    max-width: 100%;
}

.set-display-symbol {
    max-height: 1em;
    margin-left: 5px;
}

.card-in-collection {
    filter: drop-shadow(1px 1px rgba(0, 0, 0, 0.2));
}

.card-missing-in-collection {
    filter: grayscale(1);
}

.not-found-poca {
    display: block;
    max-height: 15em;
}
</style>
